import { createAsyncThunk } from "@reduxjs/toolkit";
import { CHARGING_NETWORKS } from "../../../API/UserApi";
import axios from "axios";
import apiHeader from "../../../Components/ApiHeader";

export const getNetworkListAPI: any = createAsyncThunk(
  "getNetworkList",
  async (params: any, { rejectWithValue }: any) => {
    const token: any = localStorage.getItem("token");
    const commonHead = apiHeader(token);
    try {
      const res = await axios.get(CHARGING_NETWORKS, {
        headers: commonHead,
        params: params,
      });
      return { users: res };
    } catch (error: any) {
      // if (error instanceof Error) {
      return rejectWithValue({
        error: { code: error.response.status, message: error.message },
      });
      // }
    }
  }
);
